
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const MobileRotation = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="MobileRotation" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M1.1095 6.793l-1.05.286A7.957 7.957 0 017.0765.063l-.286 1.049a6.95977 6.95977 0 00-5.681 5.681zm14.831 2.126l-1.052.287a6.971 6.971 0 01-5.684 5.681l-.286 1.05a7.973 7.973 0 007.022-7.018zm-.164-3.041L10.1195.221l-9.9 9.9 5.656 5.658zm-5.658-4.242l4.243 4.243-8.486 8.485-4.242-4.243zM5.16822 12.24171l.70735-.70686-1.41372-1.41471-.70735.70686z" />
</svg>
    </HvIconBase>
)};

MobileRotation.propTypes = HvIconBase.propTypes;

export default MobileRotation;